export const PREGUNTAS_ANTECEDENTES_PENSION = [
  {
    question: "¿Deseas pago preliminar?",
    paragraph: `Este es un <strong>pago adelantado y provisorio</strong> que puedes solicitar mientras eliges una modalidad de pensión y se calcula tu pensión definitiva.
    <br><br>
      Los pagos se realizarán:
      <ul>
        <li>Si iniciaste el trámite con la edad de pensión cumplida, se pagará desde la fecha en que haces la solicitud y hasta la selección de modalidad.</li>
        <li>En el caso que estés ingresando tu solicitud antes de la edad legal de pensión, el pago se realizará desde la fecha posterior entre el inicio del trámite y el cumplimiento de 60 o 65 años, según corresponda.</li>
        <li>En el caso de que te pensiones sin derecho a seleccionar la modalidad, los pagos se harán entre la solicitud de pensión y la emisión de la ficha de cálculo del Retiro Programado.</li>
      </ul>`,
    controlName: "preliminaryPayment",
  },
  {
    question: "¿Deseas recibir el pago de tu pensión de manera retroactiva?",
    paragraph: `<strong>Si pides un pago retroactivo,</strong> te pagarán desde la fecha en que iniciaste el trámite o desde que cumples la edad legal, considerando la fecha que haya ocurrido más tarde.
                <br><br>
                Si decides <strong>no solicitar el pago retroactivo,</strong> tu dinero seguirá generando ganancias o pérdidas según la rentabilidad de los multifondos. En este caso, comenzarás a recibir el pago una vez seleccionada la modalidad de pensión:
                <ul><li>
                Si eliges Retiro Programado, el pago se recibirá desde que firmas el formulario de selección de modalidad.</li>
                <li>Si seleccionas Renta Vitalicia, el pago se hará desde el mes que se transfiere la prima a la Compañía de Seguros.</li>
                </ul>
                <br><br>
                <strong>Importante:</strong> El pago retroactivo se descuenta de los ahorros previsionales, lo que disminuirá el saldo para financiar tu pensión mensual. Esto puede influir en las ofertas que recibas, especialmente si eliges la modalidad de Renta Vitalicia.`,
    controlName: "pagoRetroactivo",
  },
  {
    question:
      "¿Quieres ajustar tu pensión a 2 UF? En caso de que el monto sea inferior a éste?",
    paragraph:
      `Puedes solicitar que el monto de tu pensión se ajuste a 2 UF, <strong>si es que la cifra calculada es menor a esto.</strong> Además, también puedes acceder si tienes PGU, ya que ambos beneficios son compatibles.
      <br><br>
      Este ajuste es voluntario, para obtenerlo debes contar con saldo suficiente en la cuenta individual e implica agotar más rápido los ahorros previsionales. Ante dudas, te sugerimos asesorarte con un ejecutivo.`,
    controlName: "threeuf",
  },
  {
    question: "¿Solicitas el cálculo del Excedente de Libre Disposición?",
    paragraph:
      `Al pensionarte, puedes solicitar que se calcule si tienes derecho a retirar el Excedente de Libre Disposición, <strong>siempre y cuando cumplas con los requisitos:</strong>
        <ul><li>Tener a lo menos 10 años de afiliación en cualquier sistema previsional.</li>
        <li>Obtener una pensión igual o mayor al 70% del promedio de tus remuneraciones en los 10 años anteriores al mes de la solicitud de pensión.</li>
        <li>Obtener una pensión que sea igual o superior a 12 Unidades de Fomento (UF).</li>
        <li>Obtener el 100% de la Pensión Máxima con Aporte Solidario (PMAS) vigente a la fecha del cálculo.</li>
        </ul>
        <br><br>
        <strong>En caso de seleccionar no,</strong> no se calculará el Excedente de Libre Disposición, aun cuando se tenga derecho.`,
    controlName: "free",
  },
  {
    question: "¿Vas a solicitar la Pensión Garantizada Universal (PGU)?",
    paragraph:
          `Este beneficio estatal entrega un monto para todas las personas mayores de 65 años que pertenezcan al 90% de las familias más vulnerables del país, si se cumplen los requisitos. Viene a sustituir la Pensión Básica Solidaria (PBS) y el monto se reajusta anualmente por el IPC.
          <br><br>
          Si seleccionas que sí en esta pregunta, de todas formas, <strong>debes solicitarlo en el sitio web de ChileAtiende.</strong>`,
    controlName: "pgu",
  },

 {
    question: "¿Quieres que tus datos aparezcan en un listado público?",
    paragraph:
          `El listado público es un registro de la Superintendencia de Pensiones con los datos de los afiliados que están próximos a pensionarse.
          <br><br>
          Esta información <strong>sirve para que las AFP y aseguradoras puedan contactarte para ofrecer sus servicios.</strong>`,
    controlName: "publicList",
  },
  {
    question: "¿Deseas congelar tus saldos?",
     paragraph:
          `Esto significa que <strong>tus ahorros dejarán de ser invertidos en los multifondos</strong>. Con esto, podrías dejar de ganar como perder, por lo tanto, es importante que antes de solicitarlo te asesores sobre los valores cuota en la actualidad. Al congelar los saldos, tu dinero es traspasado a una Cuenta Corriente del Fondo de Pensiones.
          <p>Puedes solicitarlo desde que ingresas tu trámite de pensión hasta que seleccionas la modalidad de pensión o firmas el desistimiento del trámite.</p>

          Los plazos son:
          <ul>
          <li>Para congelar: 4 días hábiles siguientes a tu solicitud o desde el cumplimiento de la edad legal, dependiendo de cuál sea posterior.</li>
          <li>Para descongelar: es 4 días hábiles o 1 día hábil si se determina que no tienes fondos suficientes para optar a SCOMP (Sistema de Consultas y Ofertas de Montos de Pensión).</li>
          </ul>`,
    controlName: "freezenBalances",
  },
  {
    question: '¿Transferirás fondos de tu Cuenta 2 - Ahorro Voluntario al cálculo de tu pensión?',
    controlName: 'transferFundsCAV',
    title: 'Estos son tus fondos en Cuenta 2',
    type: 'CAV',
    amountControl: 'cavAmount',
    currencyControl: 'cavCurrency',
    amount: 100000
  },
  {
    question: '¿Destinarás cotizaciones de tu APV - Ahorro Previsional Voluntario al cálculo de la pensión?',
    controlName: 'transferFundsCCV',
    title: 'Estos son tus fondos en APV',
    type: 'CCV',
    amountControl: 'ccvAmount',
    currencyControl: 'ccvCurrency',
    amount: 80000
  },
  {
    question: '¿Destinarás cotizaciones de tu APVC - Ahorro Previsional Voluntario Colectivo al cálculo de la pensión?',
    controlName: 'transferFundsAPVC',
    title: 'APVC - Ahorro Previsional Voluntario Colectivo',
    type: 'CVC',
    amountControl: 'apvcAmount',
    currencyControl: 'apvcCurrency',
    amount: 80000
  }
];